<template>
  <div class="m-table-policy">
    <template v-if="len">
      <el-table ref="policyTable" :data="value" :max-height="300" border stripe>
        <el-table-column
          v-for="(col, id) in columns"
          :key="id"
          :prop="col.key"
          :label="col.title"
          :fixed="col.fixed"
          :show-overflow-tooltip="col.overflow"
          :min-width="col.width"
          :align="col.align"
          :sortable="col.sortable"
          :sort-orders="['descending', 'ascending', null]"
        >
          <template slot-scope="scope">
            <span v-if="col.key === 'convertIndex'">{{ getConvertType(scope.row[col.key]) }}</span>
            <span v-else-if="col.key === 'cpa_bid'"
              >{{ getBidValue(scope.row) }}<br v-if="getBidValue(scope.row)" />{{ getCpaBidType(scope.row) }}</span
            >
            <span v-else-if="col.key === 'deep_cpabid'"
              >{{ getDeepBidValue(scope.row) }}<br v-if="getDeepBidValue(scope.row)" />{{ getDeepCpaBidType(scope.row) }}</span
            >
            <span v-else-if="['createTime', 'updateTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
            <div v-else-if="col.key === 'control'">
              <el-button type="text" size="small" class="c-control-margin" @click="$emit('on-delete', scope.$index)">删除</el-button>
            </div>
            <span v-else>{{ scope.row[col.key] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </template>
    <div v-else class="c-nodata">
      <Icon type="ios-filing-outline" size="92" color="#efefef" />
      <span>请选择策略模板</span>
    </div>

    <policyer
      v-model="policyModal"
      :loading="loading"
      :data="policieList"
      :total="policyTotal"
      :open-id="openId"
      :platform="platform"
      @on-cancel="policyModal = false"
      @on-change="filterPolicy"
      @on-select="savePolicy"
    />
  </div>
</template>
<script>
import { timeout, isArray } from '@/common/js/utils'

import columns from './data/policy_column'
import convertData from '@/data/toutiao/convert_data'
import Policyer from '@/components/policy/manager.vue'
import mixin from './mixin'
import { listPolicy } from '@/api/manage.model'
export default {
  name: 'policySelect',
  mixins: [mixin],
  components: {
    Policyer
  },
  computed: {
    len() {
      return this.value.length
    }
  },
  props: {
    value: {
      type: Array
    },
    openId: {
      type: [Number, String]
    },
    media: {
      type: [Number, String]
    },
    platform: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getData(filter) {
      let params = {
        mediaId: this.media
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))

      this.loading = true
      listPolicy(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.policyTotal = total_number || 0
            this.policieList = list
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    filterPolicy(params) {
      this.getData(params)
    },
    savePolicy(meta) {
      this.$emit('on-select', meta)
      timeout(0).then(() => {
        this.policyModal = false
      })
    },
    selectPolicy() {
      this.policyModal = true
    },
    getBidValue(row) {
      if (row.smart_bid_type === '手动出价') {
        // SMART_BID_CUSTOM
        if (row.bid_range === 0) {
          // 固定金额
          return row.cpa_bid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.bid_num_range.join('~')
        }
      } else if (row.smart_bid_type === '自动出价') {
        // SMART_BID_CONSERVATIVE
        if (row.bid_range === 0) {
          // 固定金额
          return row.cpa_bid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.bid_num_range.join('~')
        }
      }
    },
    getCpaBidType(row) {
      if (row.smart_bid_type === '自动出价') {
        return row.adjust_cpa === 1 ? '期望出价' : row.adjust_cpa === 0 ? '系统推荐' : '换行测试'
      } else return ''
    },
    getDeepBidValue(row) {
      if (row.deep_bid_type === 'DEEP_BID_DEFAULT') {
        // 无深度优化
        return '——'
      } else if (row.deep_bid_type === 'DEEP_BID_PACING' || row.deep_bid_type === 'SMARTBID') {
        // 自动优化
        return '自动优化'
      } else if (row.deep_bid_type === 'DEEP_BID_MIN' || row.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') {
        // 自定义双出价
        if (row.deep_cpabid_range === 0) {
          // 固定金额
          return row.deep_cpabid
        } else if (row.bid_range === 1) {
          // 随机金额
          return row.deep_cpabid_num_range.join('~')
        }
      } else if (row.deep_bid_type === 'ROI_COEFFICIENT') {
        // ROI系数
        return row.roi_goal
      }
    },
    getDeepCpaBidType(row) {
      if (row.deep_bid_type === 'DEEP_BID_MIN' || row.deep_bid_type === 'AUTO_MIN_SECOND_STAGE') return '双出价'
      else if (row.deep_bid_type === 'ROI_COEFFICIENT') return 'ROI系数'
    },
    getConvertType(val) {
      const convert = this.convertData.filter((ret) => ret.key === val).pop()
      if (convert) return convert.value
      return '未知'
    }
  },
  data() {
    if (this.disabled) columns.pop()
    return {
      loading: null,
      policyModal: null,
      policieList: [],
      policyTotal: 0,
      columns: columns,
      convertData: convertData
    }
  }
}
</script>
<style lang="scss" scoped>
.m-table-policy {
  width: 100%;
  max-height: 340px;

  .c-nodata {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .ivu-icon {
      display: inline-block;
    }

    span {
      color: #bebebe;
      font-size: 14px;
    }
  }
}
</style>
